import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ProjectStageTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ProjectStageTypeModel._instance == null) ProjectStageTypeModel._instance = new ProjectStageTypeModel(authManager);
        return ProjectStageTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/project-stage-types', 'projects/project-stage-types/codelist');

        this.entityName = 'projects.ProjectStageType';
        this.privileges = {
            create: [["adminProjects"]],
            read: [["adminProjects"],["manageProjects"],["editProjects"],["readProjects"]],
            update: [["adminProjects"]],
            delete: [["adminProjects"]],
        };

        this.label = 'Project Stage Type';
        this.setLabel = 'Project Stage Types';

        this.browser = {
            name: 'default-projects-projectstagetype-browser',
            moduleName: 'default-projects-projectstagetype-browser',
            moduleTitle: 'Project Stage Types',
            moduleStateSlotName: 'default-projects-projectstagetype-browser',
        };

        this.editor = {
            name: 'default-projects-projectstagetype-editor',
            moduleName: 'default-projects-projectstagetype-editor',
            moduleTitle: 'Project Stage Type',
            moduleStateSlotName: 'default-projects-projectstagetype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
